<!--Wird eingebunden-->
<template>
  <div class="app-tariff-info-modal" v-if="tariff.tariffExtra">
    <b-modal id="tariff-info-modal"
             :modal-class="['tariff-'+ tariff.tariffExtra.class, 'tariff-info-modal']"
             size="xl"
             v-model="show_"
             data-qa="modal"
             header-bg-variant="custom"
             header-text-variant="custom"
             body-bg-variant="custom"
             body-text-variant="custom"
             footer-bg-variant="custom"
             footer-text-variant="custom"
             ok-only ok-title="Schließen"

    >
      <div slot="modal-title" :class ="['detail-box-top', 'tariff-' + tariff.tariffExtra.class]">
        {{tariff.name}}
      </div>
      <TariffOverview :tariff="tariff">
        <template v-for="slot in possibleChildSlotsFor('TariffOverview')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </TariffOverview>
    </b-modal>
  </div>
</template>

<script>

import { BModal } from 'bootstrap-vue'
import slotProxy from '@/mixins/slotProxy'
import syncProperty from '@/mixins/syncProperty'
import TariffOverview from '../../../../LIDL/TariffOverview.vue'

export default {
  name: 'TariffInfoModal',
  mixins: [
    slotProxy(),
    syncProperty('show', 'show_')
  ],
  components: { TariffOverview, BModal },
  computed: {
    slotData: function () {
      return this.tariff
    }
  },
  props: {
    tariff: {
      type: Object,
      default: () => {}
    }
  }
}

</script>
